import React from 'react'
import "./AboutTabContent.css"

const AboutTabvission = () => {
    return (
        <div className="about-tab-contents">
            <h2 className="about-tab-contents-h2">
                Our vision
            </h2>
            <p className="about-tab-contents-p">
                Our vision is to be the pillar of reliability in the logistics industry. We aim to set the standard for time-sensitive and high-stakes logistics, ensuring minimal risk and maximum efficiency for all our clients across the globe.
            </p>
            <ul>
                <li>Global reach with local expertise.</li>
                <li>Innovation in temperature-controlled logistics.</li>
                <li>Excellence in freight forwarding.</li>
                <li>Customer-centric logistical solutions.</li>
            </ul>
        </div>
    )
}

export default AboutTabvission
